export interface Drill {
  id: number;
  title: string;
  category?: string | null;
  description?: string | null;
  durationMinutes?: number | null;
  players?: string | null;
  equipment?: string | null;
  ageGroupHint?: string | null;
  /** A rajzszerkesztő ábrája JSON-ként. */
  diagram?: string | null;
  createdByUserId: number;
  createdByName: string;
  createdAt: string;
  updatedAt?: string | null;
  /** Szerkesztheti/törölheti-e a bejelentkezett felhasználó (szerző vagy admin). */
  canModify: boolean;
}

export interface SaveDrillRequest {
  title: string;
  category?: string | null;
  description?: string | null;
  durationMinutes?: number | null;
  players?: string | null;
  equipment?: string | null;
  ageGroupHint?: string | null;
  diagram?: string | null;
}

/** A gyakorlatok kategóriái - a szerver szabad szövegként tárolja, a lista itt él. */
export const DRILL_CATEGORIES = [
  'Bemelegítés',
  'Technika',
  'Passzjáték',
  'Befejezés',
  'Kisjáték',
  'Taktika',
  'Kondíció',
  'Kapus',
  'Levezetés',
] as const;
